import { render, staticRenderFns } from "./CoozzySpamIcon.vue?vue&type=template&id=19c8260c&scoped=true"
import script from "./CoozzySpamIcon.vue?vue&type=script&lang=js"
export * from "./CoozzySpamIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c8260c",
  null
  
)

export default component.exports